import { AuthLayout } from "../../../components/layout/auth-layout/auth-layout.tsx";
import { ResetPasswordForm } from "../../../components/features/auth/forms/reset-password-form.tsx";
import { useSqeLabs } from "../../../hooks/use-sqe-labs.ts";
import { SQE_AUTH_LAYOUT_PROPS } from "../login-page/sqe-auth-layout.tsx";
import styles from "../login-page/login-page.module.css";

export default function ResetPasswordPage() {
  const isSqeLabs = useSqeLabs();
  return (
    <div className={styles.page}>
      <AuthLayout
        {...(isSqeLabs ? SQE_AUTH_LAYOUT_PROPS : {})}
        title="Set your new password"
        subtitle="Please choose a strong password that you haven't used before."
      >
        <ResetPasswordForm />
      </AuthLayout>
    </div>
  );
}
